module.exports = __webpack_public_path__ + "img/cg.5d8fc2e5.svg";